import { BaseEvent } from "@/api/ws/events/BaseEvent";

export default class BorrowerConnectedToProfileEvent extends BaseEvent<{ id: number }> {
  name = "BorrowerPlatform\\BorrowerConnectedToProfile";
}
